import React from 'react';
import SvgIcon from '../../../components/SvgIcon';

type Props = {
    iconSize?: number;
    width?: number;
    height?: number;
    mr?: number;
};

const FeedCenterStatisticsReregisterSuccessIcon = ({
    iconSize = 32,
    width = 64,
    height = 64,
    mr = 12,
}: Props) => {
    return (
        <div
            className="flex shrink-0 items-center justify-center rounded-full"
            style={{
                width,
                height,
                marginRight: mr,
                border: '1px solid #B6E8D9',
                backgroundColor: '#EAF8F4',
            }}
        >
            <SvgIcon name="SvgCenterStatisticsReregisterSuccess" size={iconSize} fill="#169873" />
        </div>
    );
};

export default FeedCenterStatisticsReregisterSuccessIcon;
